import React, { useEffect } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';

import { useDocumentTitle } from '../../hooks/useDocumentTitle';
import { usePagination } from '../../hooks/usePagination';
import { useApiQuery } from '../../hooks/useApiQuery';
import { list } from '../../apis/products';

import { SearchBreadcrumb } from '../../components/search/SearchBreadcrumb';
import { ProductsGrid } from '../../components/products/ProductsGrid';
import { SearchEmpty } from '../../components/search/SearchEmpty';
import { SearchForm } from '../../components/search/SearchForm';
import { EmptyCard } from '../../components/common/ui/EmptyCard';

export const SearchPage = () => {
    useDocumentTitle('Search');

    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const category = searchParams.get('category') || '';
    const filter = searchParams.get('filter') || '';

    const { pagination, setPagination, handlers } = usePagination({
        page: 1,
        size: 12,
        category,
        filter
    });

    const products = useApiQuery(list, pagination);

    useEffect(() => {
        setPagination({
            page: 1,
            size: 12,
            category,
            filter
        });
    }, [category, filter]);

    const handleSearch = (form) => {
        setSearchParams({
            filter: form.filter,
            category: form.category
        });
    };

    return (
        <div className="search-page mb-5">
            <h1 className="h3">Search</h1>
            <SearchBreadcrumb filter={filter} category={category} />
            <SearchForm filter={filter} category={category} onSubmit={handleSearch} />
            {products.isLoading || products.data.records.length > 0 ? (
                <ProductsGrid className="mt-3" {...handlers} {...products} />
            ) : (
                <EmptyCard icon="gift" text="Results not found">
                    <Link className="btn btn-outline-primary" to="/search">
                        Clear filters
                    </Link>
                </EmptyCard>
            )}
        </div>
    );
};
